export enum EEquipmentType {
    SCANNER = 1,
    MILLING = 2,
    PRINTER = 3,
    FURNACE = 4,
    OTHER = 10,
}
